import { useEffect, useState } from "react";
import "../global/basic.css"
import "./stats.css"
import { API_URL } from "../shared/api";
import useBackupUser from "../shared/hooks/useBackupUser";
import MainComponent from "../global/mainlayout/MainComponent";
import FancyToggle from "../shared/components/FancyToggle"
import { FinalScoreStatsComponent } from "./FinalScoreStatsComponent";
import { JokerStatsComponent } from "./JokerStatsComponent";
import { PrecisionStatsComponent } from "./PrecisionStatsComponent";
import { OnePercentStatsComponent } from "./OnePercentStatsComponent"

export default function StatsPage() {
  const options = ["Ergebnis", "Joker", "Präzision", "Gewinn"]
  
  const [selected, setSelected] = useState(options[0])
  const user = useBackupUser();
  const [games, setGames] = useState([]);

  useEffect(() => {
    if(!user)
      return

    fetch(`${API_URL}/users/${user?.id}/games`, {method: "GET"})
      .then(r => r.json())
      .then(x => x.filter(g => g.stats.isCompleted))
      .then(setGames)
  }, [user?.id, user])


  return (
    <MainComponent title="Spielstatistik" >
      <FancyToggle className="bottom-margin" options={options} selected={selected} onSelectionChange={setSelected}/>
      
      {selected === options[0]
      ? <FinalScoreStatsComponent data={games} />
      : selected === options[1] 
      ? <JokerStatsComponent data={games} />
      : selected === options[2]
      ? <PrecisionStatsComponent data={games} />
      : <OnePercentStatsComponent data={games} />
      }
      
    </MainComponent>
  );
}

